import { api } from 'lib/httpClient';

export const getInvestmentList = (value) => {
  return () => {
    return api
      .post(`investment/get-investees`, value)
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
};
